'use client';

import { c as _c } from "react/compiler-runtime";
import { InfoCircle } from '@byway/icons';
import { Disclosure } from '~/components/Disclosure';
import type { TicketingInstructionProps } from './TicketingInstruction.types';
import { TicketingInstructionContent } from './TicketingInstructionContent';
const TicketingInstruction = t0 => {
  const $ = _c(7);
  const {
    staticContent,
    dynamicContent
  } = t0;
  const {
    title
  } = staticContent;
  const t1 = title ?? "";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <InfoCircle ariaLabel="Information" strokeWidth={2} size="large" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== dynamicContent || $[2] !== staticContent) {
    t3 = <TicketingInstructionContent staticContent={staticContent} dynamicContent={dynamicContent} />;
    $[1] = dynamicContent;
    $[2] = staticContent;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = <Disclosure title={t1} size="md" leadingElement={t2} showChevron={true} headerColour="blueSecondary">{t3}</Disclosure>;
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export { TicketingInstruction };